
// Sound played when a chat notification is shown in-app. Desktop and mobile get a
// different one on purpose: a phone sits closer to the ear and next to the OS's own
// tones, so it wants the shorter, drier blip. Other variants live in /assets/audio:
//   chat-ios.mp3          the desktop tone
//   chat-blip.wav         a dry messenger style note
//   chat-blip-double.wav  the same note twice, a beat apart
//   chat-pop.wav          one short bubble, the most discreet
//   chat-chime.wav        two rising bell notes
//   chat-marimba.wav      a warm wooden note
//   chat-glass.wav        an airy ping with a long shimmer
const CHAT_SOUND_DESKTOP = "/assets/audio/chat-ios.mp3"
const CHAT_SOUND_MOBILE = "/assets/audio/chat-pop.wav"

// Same threshold useScreen() uses for isMobile. Read at play time rather than
// captured, since the socket handler that calls this is registered only once.
const MOBILE_MAX_WIDTH = 600

const players: { [src: string]: HTMLAudioElement } = {}

// Browsers refuse to play audio until the user has interacted with the page, and
// a rejected play() must not bubble up into the socket handler that called it.
export function playChatNotificationSound() {
    try {
        const src = window.innerWidth < MOBILE_MAX_WIDTH ? CHAT_SOUND_MOBILE : CHAT_SOUND_DESKTOP

        if (!players[src]) {
            players[src] = new Audio(src)
            players[src].volume = 0.55
        }

        players[src].currentTime = 0
        players[src].play()?.catch(() => undefined)
    }
    catch { }
}
